import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-files-upload',
  templateUrl: './fh-svg-files-upload.component.html',
  styleUrl: './fh-svg-files-upload.component.scss'
})
export class FhSvgFilesUploadComponent {
  @Input() color: string = '';
}
